import { render } from "./Footer.vue?vue&type=template&id=33af3c5b"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/navigation/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33af3c5b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33af3c5b', __exports__)) {
    console.log('reload')
    api.reload('33af3c5b', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=33af3c5b", () => {
    console.log('re-render')
    api.rerender('33af3c5b', render)
  })

}


export default __exports__